import Actions from '@ppcp/actions';

const actions = new Actions();

/**
 * For a free trial with nothing due today, Apple Pay's payment sheet still needs to show the
 * subscription's recurring total - not the live $0 total - since the server creates/authorizes
 * the PayPal order for that same recurring amount purely to vault the payment method (see
 * SubscriptionController::maybe_authorize_order_for_vaulting()). PayPal rejects the payment if
 * the amount the buyer authorized in the wallet doesn't match the order it's confirming - this
 * applies both to the initial payment request and to any newTotal shown after the buyer changes
 * their shipping address/method/payment method mid-session.
 *
 * The recurring total is exposed on cart data (via wc_ppcp_cart_data ->
 * SubscriptionController::add_recurring_total_to_cart_data()) rather than the cart's own total,
 * so it stays available across cart/shipping AJAX updates without touching the value other
 * gateways/consumers of Cart.js rely on.
 */
const useRecurringTotal = (data, gateway) => {
    const recurringTotal = gateway?.controller?.cart?.data?.recurringTotal;
    if (recurringTotal && data.total) {
        data.total.amount = recurringTotal;
    }
    if (recurringTotal && data.newTotal) {
        data.newTotal.amount = recurringTotal;
    }
    return data;
};

actions.addFilter('applepay_payment_request', useRecurringTotal);
actions.addFilter('applepay_complete_payment_method_selection', useRecurringTotal);
actions.addFilter('applepay_complete_shipping_method_selection', useRecurringTotal);
actions.addFilter('applepay_complete_shipping_contact_selection', useRecurringTotal);